import { JSX, use, useMemo, Suspense } from 'react'


import * as archive_storage from '@/storage/archive.js'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loading from '@/components/ui/loading.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Contract from '@/views/supervisor/contract'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Retrieve
(
	props: {
		_id: Promise<string>

	},

)
:	JSX.Element
{
	let _id = use(props._id)

	return (
		<Contract _id={_id} />

	)

}

export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	let _id = useMemo(
		() => archive_storage.retrieve_contract(props._id)
			.then(
				doc => doc._id,

			)
			.catch(
				() => '',

			),

		[props._id],

	)


	return (
		<Suspense fallback={<Loading.Default />}>
			<Retrieve _id={_id} />

		</Suspense>

	)

}
